"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KHEventHandler = void 0;
class KHEvent {
    constructor(name) {
        this.name = name;
        this.callbacks = [];
        this.callbackMap = new Map();
        this.onceCallbacks = [];
        this.onceCallbackMap = new Map();
    }
    registerCallback(cb) {
        this.callbacks.push(cb);
    }
    registerCallbackForObject(obj, cb) {
        const arr = this.ensureExists(this.callbackMap, obj);
        arr.push(cb);
        this.registerCallback(cb);
    }
    registerOnceCallback(cb) {
        this.onceCallbacks.push(cb);
    }
    registerOnceCallbackForObject(obj, cb) {
        const arr = this.ensureExists(this.onceCallbackMap, obj);
        arr.push(cb);
        this.registerOnceCallback(cb);
    }
    unregisterCallback(cb) {
        let idx = this.callbacks.indexOf(cb);
        if (idx < 0)
            return;
        this.callbacks.splice(idx, 1);
    }
    unregisterCallbacksForObject(obj) {
        const arr = this.callbackMap.get(obj);
        if (arr) {
            for (let cb of arr) {
                this.unregisterCallback(cb);
            }
            this.callbackMap.delete(obj);
        }
        const onceArr = this.onceCallbackMap.get(obj);
        if (onceArr) {
            for (let cb of onceArr) {
                this.unregisterOnceCallback(cb);
            }
            this.onceCallbackMap.delete(obj);
        }
    }
    unregisterOnceCallback(cb) {
        let idx = this.onceCallbacks.indexOf(cb);
        if (idx < 0)
            return;
        this.onceCallbacks.splice(idx, 1);
    }
    emitEvent(data) {
        this.callbacks.forEach(function (callback) {
            callback(data);
        });
        this.onceCallbacks.forEach(callback => {
            callback(data);
        });
        this.onceCallbacks = [];
        this.onceCallbackMap.clear();
    }
    ensureExists(map, key) {
        let arr = map.get(key);
        if (!arr) {
            arr = [];
            map.set(key, arr);
        }
        return arr;
    }
}
class KHEventHandler {
    constructor() {
        this.events = new Map();
    }
    ensureEvent(name) {
        let val = this.events.get(name);
        if (!val) {
            val = new KHEvent(name);
            this.events.set(name, val);
        }
        return val;
    }
    emitEvent(name, args) {
        this.ensureEvent(name).emitEvent(args);
    }
    registerCallback(name, listener) {
        this.ensureEvent(name).registerCallback(listener);
    }
    on(name, listener) {
        this.registerCallback(name, listener);
    }
    registerCallbackForObject(name, registrar, listener) {
        this.ensureEvent(name).registerCallbackForObject(registrar, listener);
    }
    onFor(name, registrar, listener) {
        this.registerCallbackForObject(name, registrar, listener);
    }
    registerOnceCallback(name, listener) {
        this.ensureEvent(name).registerOnceCallback(listener);
    }
    onceFor(name, registrar, listener) {
        this.registerOnceCallbackForObject(name, registrar, listener);
    }
    once(name, listener) {
        this.registerOnceCallback(name, listener);
    }
    registerOnceCallbackForObject(name, registrar, listener) {
        this.ensureEvent(name).registerOnceCallbackForObject(registrar, listener);
    }
    unregisterCallback(name, cb) {
        this.ensureEvent(name).unregisterCallback(cb);
    }
    off(name, cb) {
        this.unregisterCallback(name, cb);
    }
    unregisterCallbacksForObject(name, registrar) {
        let val = this.events.get(name);
        if (val) {
            val.unregisterCallbacksForObject(registrar);
        }
    }
    offFor(name, registrar) {
        this.unregisterCallbacksForObject(name, registrar);
    }
    unregisterAllCallbacksForObject(registrar) {
        for (let event of this.events.values()) {
            event.unregisterCallbacksForObject(registrar);
        }
    }
    offAllFor(registrar) {
        this.unregisterAllCallbacksForObject(registrar);
    }
}
exports.KHEventHandler = KHEventHandler;
